import {useEffect, useState} from 'react';
import {YouInvest} from 'src/Api';
import MorningstarComponentLoader from "src/MarketDataComponents/MorningstarComponentLoader";

export const DATA_TYPE_GROWTH10K = 'growth10K';
export const DATA_TYPE_PRICE = 'price';
export const DATA_TYPE_PRICEANDNAV = 'priceAndNav';

export default function Charting({chartSettings}) {
    const containerId = chartSettings.containerId ? chartSettings.containerId : 'advanced-chart';

    useEffect(() => {
        const init = async () => {
            if (!window.loader) {
                window.loader = await require('../../../public/js/lib/ec-component-loader-1.3.0.min.js');
            }
            fetch(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/morningstar-oauth-token`, {
                method: 'GET',
                headers: YouInvest.getTradingRequestHeaders()
            }).then(async (res) => {
                const json = await res.json();                
                const loader = new MorningstarComponentLoader(json)

                loader.initComponent(
                    window, 
                    containerId, 
                    { 'markets-components-svgchart': chartSettings },
                    () => {
                        console.log('error');
                    }
                );
            })
        }        
        init();      
    }, []);

    return <div id={containerId}></div>

}